module.exports = __webpack_public_path__ + "static/img/yun01_4.0eb28d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/yun01_4.jpg
// module id = W+2h
// module chunks = 1